import React from 'react';
import Typo from '../Typography';

type TBreadcrumbsProps = {
  children: React.ReactNode;
  separator?: React.ReactNode;
};

const DefaultSeparator = () => <Typo className="text-[22px] leading-[36px] text-t2-neutral-grey03">/</Typo>;

export const Breadcrumbs: React.FC<TBreadcrumbsProps> = ({ children, separator = <DefaultSeparator /> }) => {
  const items = React.Children.toArray(children);

  const isLast = (index: number) => index === items.length - 1;
  return (
    <nav aria-label="breadcrumb" className="w-full overflow-hidden">
      <ul className="flex items-center space-x-2 min-w-0">
        {items.map((child, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} className="flex items-center min-w-0">
            <span className="truncate text-ellipsis overflow-hidden min-w-0">{child}</span>
            {!isLast(index) && <span className="ml-2 text-gray-500">{separator}</span>}
          </li>
        ))}
      </ul>
    </nav>
  );
};
